export default __webpack_public_path__ + "static/media/img_15.34f969e7.jpg";